import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

const isCardSelected = (shortName, selectedCards) => {
  return selectedCards.indexOf(shortName) > -1;
};

/* eslint-disable max-params */
export const addRemoveCtaHandler = (
  cardTitle,
  { ...onClickProps },
  addCardToCompare = () => {},
  removeCardFromCompare = () => {},
  fromCta = false,
  changeAriaMessage = () => {},
  shortName
) => {
  const {
    addToCompare,
    removeFromCompare,
    addCompareDtm,
    selectedCards
  } = onClickProps;
  const isCardInTray = isCardSelected(shortName, selectedCards);
  const {
    ctaCheck: checkCompareDtmTag = {},
    ctaUncheck: uncheckCompareDtmTag = {}
  } = addCompareDtm;
  let dtmObj = Object.assign({}, fromCta ? checkCompareDtmTag : addToCompare.dtmTag);

  if (isCardInTray) {
    dtmObj = Object.assign(
      {},
      fromCta ? uncheckCompareDtmTag : removeFromCompare.dtmTag
    );
    removeCardFromCompare(shortName);
  } else {
    addCardToCompare(shortName);
  }
  dtmObj.eventAsset = dtmObj.eventAsset + ':' + shortName;
  sendDTMClickEvent(dtmObj);
  changeAriaMessage(cardTitle);
};

export const calculateTabIndex = (styles, shownArrows, arrowType) => {
  const showLeftOnly = styles.showLeftArrowOnly === shownArrows;
  const showRightOnly = styles.showRightArrowOnly === shownArrows;
  const showBothArrows = styles.showBothArrows === shownArrows;
  const initialStyle = styles.hideBothArrows === shownArrows;
  if (showBothArrows) return 0;
  if (arrowType === 'right') {
    if (showRightOnly || initialStyle) {
      return 0;
    } else {
      return -1;
    }
  } else if (arrowType === 'left') {
    if (showLeftOnly) {
      return 0;
    } else {
      return -1;
    }
  }
};
